import { PARKING_TYPES, SANITARY_FEATURES } from 'cpool-constants';
import { z } from 'zod';

import { schemaInteger } from '../../../utils/schema.utils';

export const schemaBaubeschreibungSanitaerGaragen = z.object({
    garagenStellplaetze: z
        .array(
            z.object({
                anzahl: schemaInteger.positive(),
                art: z.nativeEnum(PARKING_TYPES),
            }),
        )
        .refine((entries) => new Set(entries.map(({ art }) => art)).size === entries.length, {
            message: 'Parking types must be unique',
        })
        .default([]),
    sanitaereEinrichtung: z
        .array(z.nativeEnum(SANITARY_FEATURES))
        .refine((entries) => new Set(entries).size === entries.length, {
            message: 'Sanitary features must be unique',
        })
        .default([]),
});

export type SchemaBaubeschreibungSanitaerGaragen = z.infer<typeof schemaBaubeschreibungSanitaerGaragen>;
